export const formatToolName = (name) => {
  if (!name) return "N/A";

  return name
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
